(function () {
    'use strict';
    var module = angular.module('uwAgenda.website');
    module.controller('WebsiteOverviewController', [
        '$scope',
        'WebsiteGeneratorService',
        WebsiteOverviewControllerFn]);

    /* controller for WebsiteGenerator-overview */
    function WebsiteOverviewControllerFn(
        $scope,
        WebsiteGeneratorService
    ) {

        var vm = this;
        vm.WebsiteGeneratorService = WebsiteGeneratorService
        
        //start page
        activate();

        function activate() {
            WebsiteGeneratorService.SetInitialLinkValues();
            listen();
        }
        
        // listen
        function listen() {
            let selectedLanguageWatcher = $scope.$watch(function () {
                return WebsiteGeneratorService.data.filterData.selectedLanguage;
            }, function (newVal, oldVal) {
                WebsiteGeneratorService.refreshLinks();
            });

            // destroy
            $scope.$on("$destroy", function () {
                selectedLanguageWatcher();
                selectedLanguageWatcher = null;
            });
        } // listen

    }
})();
